.errorPopover {
  max-height: 288px;
  max-width: 260px;
}

.suggestionsPopover {
  max-height: 288px;
  max-width: 260px;
  overflow: auto;
  padding: var(--space-sm) var(--space-xs);
}

.list {
  display: flex;
  flex-direction: column;
}

.item {
  border-radius: var(--border-radius-sm);
  color: var(--color-text-neutral);
  cursor: pointer;
  margin-bottom: var(--space-2xs);
  padding: var(--space-xs);

  &:last-child {
    margin-bottom: 0;
  }
}

.valid {
  color: var(--color-text-brand);
}
